import { ServiceType } from './__generated__/globalTypes';

export const DENIED_USER_SESSION_STATE = 'denied';
export const AUTHENTICATED_USER_SESSION_STATE = 'authenticated';
export const SKIP_AUTH_CONTEXT_KEY = 'skipAuth';

// Sorted alphabetically to ease adding/removing/finding constants
export const CLIENT_FEATURE_FLAGS = Object.freeze({
  AMPLITUDE_USE_AMPLI: 'amplitude-taxonomy-enable-ampli-events',
  AUTH0_PASSWORD_RULES: 'auth0-password-rules',
  BIRTHDATE_9_MONTHS_OUT: 'enrollment-birthdate-9-months-out',
  CC_ENROLLMENT_CZEN_TESTCELL_IDS: 'cc-enrollment-czen-testcell-ids',
  CZEN_TESTCELL_REFERENCEID_MAP: 'czen-testcell-referenceid-map',
  CC_OPTIONAL_PAJ: 'seeker-cc-mfe-optional-paj',
  CSC_SESSION_COOKIE_FLOW: 'enrollment-mfe-csc-session-cookie-flow',
  COOKIE_FLOW_AUTH: 'enrollment-mfe-cookie-flow-auth',
  DAYCARE_AUTO_ACCEPT_BACKEND: 'enrollment-mfe-daycare-auto-accept-leads-backend',
  DAYCARE_DISTANCE_TRAVELED_SELECTION: 'daycare-distance-traveled-selection',
  DAYCARE_ENROLLMENT_EMAIL_BANNER: 'daycare-enrollment-email-banner',
  DAYCARE_ENROLLMENT_EARLY_PREMIUM_INTRO_FLOW: 'daycare-enrollment-early-premium-intro',
  DAYCARE_ENROLLMENT_RECOMMENDATIONS_URGENCY_BANNER:
    'daycare-enrollment-recommendations-urgency-banner',
  DAYCARE_ENROLLMENT_UPDATE_RECOMMENDATIONS_TO_SHOW_UPTO_7:
    'daycare-enrollment-update-recommendations-to-show-up-to-7',
  DAYCARE_ENROLLMENT_PHONE_VERIFY: 'daycare-enrollment-phone-verify',
  DAYCARE_HDYHAU: 'growth-dc-enrollment-hdyhau-removal',
  DAYCARE_JUST_BROWSING_VS_NO_RUSH: 'growth-dc-enrollment-just-browsing-vs-no-rush',
  DAYCARE_LEADS_REDIRECTION: 'growth-enrollment-mfe-daycare-leads-redirection',
  DAYCARE_REDUCED_FUNNEL_V2: 'daycare-enrollment-flow-reduce-v2',
  DAYCARE_REDUCED_FUNNEL_HOLDOUT: 'daycare-enrollment-reduced-holdout',
  DAYCARE_REDIRECT_TO_BUSINESS_SEARCH_MFE:
    'daycare-redirect-from-enrollment-mfe-to-business-search-mfe',
  ENROLLMENT_RECOMMENDATIONS_FLOW_OPTIMIZATION:
    'enrollment-mfe-in-facility-enrollment-recommendations-and-flow-optimizations',
  GROWTH_RETURN_KEY_TO_ADVANCE: 'growth-all-enrollment-return-to-advance',
  GROWTH_SC_TYPE_OF_CARE: 'growth-senior-care-type-of-care',
  HDYHAU: 'enrollment-mfe-seeker-hdyhau',
  OVERALL_REPORTING_ONLY_MISSING_ZIPCODE_REDIRECT:
    'growth-all-enrollment-overall-reporting-only-missing-zipcode-redirect',
  INSTANT_BOOK_ENROLLMENT_DIRECT_TO_BOOKING: 'growth-cc-enrollment-direct-to-booking',
  INSTANT_BOOK_CARE_KIND_MERCHANDISING: 'growth-cc-enrollment-care-kind-ib-merchandising',
  LEAD_CONNECT_MFE_REDIRECT: 'lead-connect-mfe-redirect',
  LEAD_CONNECT_PROVIDER_NETWORK: 'sc-seeker-lc-pn-integration',
  LEAD_CONNECT_FIFTEEN_CAREGIVERS: 'lead-connect-fifteen-caregiver-max',
  LEAD_CONNECT_RECAP_SCREEN: 'enrollment-mfe-remove-lead-connect-recap-screen',
  MISSING_ZIPCODE_REDIRECT: 'growth-all-enrollment-missing-zipcode-redirect',
  PASSWORD_REQUIREMENTS_COPY: 'growth-all-enrollment-auth0-password-requirements-copy',
  PN_DAYCARE_ENROLLMENT_FLOW: 'pn-daycare-enrollment-flow',
  PN_PROVIDER_REACT_COMPONENTS_SHARED_PROFILE_CORE_ENROLLMENT:
    'pn-provider-react-components-shared-profile-core-enrollment',
  PROJECT_GREAT_MIGRATION_SESSION_STORAGE: 'growth-cc-project-great-migration-session-storage',
  PROVIDER_CC_ENROLLMENT_TEXT_ANALYZER: 'provider-cc-enrollment-text-analyzer',
  PROVIDER_CC_FREE_GATED_EXPERIENCE: 'provider-cc-free-gated-experience',
  PROVIDER_VACCINE_INDICATOR_SENIOR: 'provider-vaccine-indicator-senior',
  SAFETY_SIFT_OLD_CONSOLE_ENABLED: 'safety-sift-science-enabled',
  SAFETY_SIFT_USER_JOURNEY_ENABLED: 'safety-sift-user-journey-enabled',
  SEEKER_ENROLLMENT_MFE_DOB_CHILD: 'seeker-enrollment-mfe-dob-child',
  SEEKER_CC_REBRANDED_ENROLLMENT: 'seeker-cc-mfe-rebranded-enrollment',
  SKIP_LOGIN_IN_RATECARD_REDIRECTION: 'skip-login-in-ratecard-redirection',
  SEEKER_NAME_SPECIAL_CHARS_VALIDATION: 'growth-cc-enrollment-names-validation',
  SEEKER_PRE_RATE_CARD: 'seeker-pre-ratecard',
  SEEKER_SC_SOCIAL_ENROLLMENT: 'growth-sc-enrollment-social-sign-up',
  SEEKER_CC_SOCIAL_ENROLLMENT: 'growth-cc-display-google-apple-signup-options',
  SEEKER_DC_SOCIAL_ENROLLMENT: 'growth-dc-display-google-apple-signup-options',
  SEEKER_HK_SOCIAL_ENROLLMENT: 'growth-hk-display-google-apple-signup-options',
  SEEKER_PC_SOCIAL_ENROLLMENT: 'growth-pc-display-google-apple-signup-options',
  SEEKER_TU_SOCIAL_ENROLLMENT: 'growth-tu-display-google-apple-signup-options',
  SESSION_STORAGE_RETRIEVAL_SUCCESS: 'growth-all-session-storage-retrieval-success',
  SKIP_STEPS_SEO: 'growth-all-enrollment-skip-steps-seo',
  SKIP_STEPS_SEM: 'growth-all-enrollment-skip-steps-sem',
  ACCOUNT_CREATION_RACE_CONDITION_DELAY: 'growth-account-creation-race-condition-delay',
  TRACK_CLICK_GQL_CALL: 'growth-track-click-gql',
  TTP_ASSET_URL: 'ttp-asset-url',
  FGE_WEB_BASED_PAYMENT_TEST: 'fge-web-based-payment-test',
  OPTIMIZED_PETCARE: 'growth-petcare-ib-optimization',
  PROJECT_747_FLAG: 'proj-747-provider-enrollment-optimization-mwd-flag',
  ENABLE_DOG_WALKING_TO_IB: 'growth-pc-enrollment-dog-walking-to-ib',
  MV_PTA: 'mv_PTA',
  MV_LIMITED_VERTICAL_SELECTION: 'mv_limited_PTA',
  MV_UNLIMITED_VERTICAL_SELECTION: 'mv_unlimited_PTA',
  GROWTH_PC_ENROLLMENT_PAJ: 'growth-pc-enrollment-paj',
  GROWTH_ENROLLMENT_LOGGED_IN_REDIRECT: 'growth-enrollment-logged-in-user-redirect',
  SEEKER_CC_SKIP_CARE_KIND_SEO: 'growth-cc-enrollment-skip-care-kind-seo',
  PROVIDER_MV_ENROLLMENT_SHOW_ONLY_PRIMARY_VERTICAL:
    'provider-mv-enrollment-show-only-primary-vertical',
  GROWTH_SEEKER_SCREEN_VIEWED_SPLUNK: 'growth-enrollment-screen-viewed-splunk',
  GROWTH_HIGH_INTENT_PREMIUM_UPGRADE_FLOW: 'growth-high-intent-premium-upgrade',
  SEEKER_ENROLLMENT_LOG_IN_LINK: 'growth-cc-sc-hk-pc-tu-dc-enrollment-log-in-link',
  GROWTH_HK_ENROLLMENT_PAJ_DAY1: 'growth-hk-enrollment-paj-day1',
  GROWTH_ENROLLMENT_ALL_EMAIL_HEADLINE_UPDATES: 'growth-enrollment-all-email-headline-updates',
  GROWTH_ENROLLMENT_CC_LOADING_SCREENS: 'growth-enrollment-cc-loading-screen-designs',
  GROWTH_CAPTURE_MULTI_VERTICAL: 'growth-cc-sc-pc-tu-enrollment-mv',
  OOH_DAYCARE_TOUR_SCHEDULER_ENABLED: 'ooh-daycare-tour-scheduler-enabled',
  GROWTH_VHP_ENROLLMENT_ADD_LOG_IN_LINK: 'growth-vhp-enrollment-add-log-in-link',
  GROWTH_SC_MOVE_CAREGIVER_TASKS_TO_PAJ: 'growth-sc-move-caregiver-tasks-to-paj',
  GROWTH_SC_HELP_TYPE_SCREEN_V1: 'growth-sc-help-type-screen-v1',
  GROWTH_ENROLLMENT_CC_REMOVE_DC_SEM_GENERIC_CAMPAIGN:
    'growth-enrollment-cc-remove-dc-sem-generic-campaign',
  GROWTH_NAMES_SPECIAL_CHARS_SOFT_VALIDATION: 'growth-enrollment-names-soft-validation',
  GROWTH_ENROLLMENT_MAGIC_LINK: 'growth-enrollment-magic-link',
  GROWTH_SEO_SEEKER_SINGLE_PAGE_ENROLLMENT: 'growth-seo-seeker-single-page-enrollment',
  GROWTH_SC_MAPPING_ON_ZIPCODE: 'growth-sc-mapping-on-zipcode',
  CC_PAYWALL_TEST: 'growth-enrollment-cc-paywall-test',
  GROWTH_CC_MAPPING_ON_ZIPCODE: 'growth-cc-mapping-on-zipcode',
  CC_HK_PC_TU_REMOVE_SKIP_PASSWORD: 'growth-enrollment-cc-hk-pc-tu-remove-skip-password',
  GROWTH_SC_ALIGN_NOT_SURE_FLOW_TO_IN_HOME: 'growth-sc-align-not-sure-flow-to-in-home',
} as const);

export const SERVER_FEATURE_FLAGS = Object.freeze({
  SENTRY_TRACE_TRANSACTION_SAMPLING_RATES: 'sentry-trace-transaction-sampling-rates',
  GTM_ENABLED: 'gtm-enabled',
  GTM_JS_URL: 'gtm-js-url',
});

export const WINDOW_SENTRY_TRACE_TRANSACTION_SAMPLING_RATES_KEY =
  'SENTRY_TRACE_TRANSACTION_SAMPLING_RATES';

export const GTM_SLOTS = Object.freeze({
  DAYCARE_LEADS_SUBMITTED: ['/us-marketplace/seniorcare/caring-leads-submitted/'],
  SENIORCARE_LEADS_VIEWED_NON_ENROLLMENT: [
    '/us-marketplace/segment/seeker/sc/internal-leads-viewed/non-enrollment',
  ],
  SENIORCARE_LEADS_SUBMITTED_NON_ENROLLMENT: [
    '/us-marketplace/conversion/seeker/sc/internal-lead/non-enrollment',
  ],
  SENIORCARE_LEADS_VIEWED_ENROLLMENT: [
    '/us-marketplace/segment/seeker/sc/internal-leads-viewed/enrollment',
  ],
  SENIORCARE_LEADS_SUBMITTED_ENROLLMENT: [
    '/us-marketplace/conversion/seeker/sc/internal-lead/enrollment',
  ],
});

export const LEAD_SOURCES = Object.freeze({
  ENROLLMENT: 'ENROLLMENT',
  NTH_DAY: 'NTH DAY',
});

export const SEEKER_ROUTES = Object.freeze({
  INDEX: '/seeker/sc',
  LOCATION: '/seeker/sc/location',
  MULTI_VERTICAL: '/seeker/sc/care-multi-vertical',
  CARE_TYPE: '/seeker/sc/care-type',
  HELP_TYPE: '/seeker/sc/help-type',
  RECAP: '/seeker/sc/recap',
  ACCOUNT_CREATION: '/seeker/sc/account-creation',
  ACCOUNT_CREATION_NAME: '/seeker/sc/account-creation/name',
  ACCOUNT_CREATION_PASSWORD: '/seeker/sc/account-creation/password',
  ACCOUNT_CREATION_V2: '/seeker/sc/v2/account-creation/email',
  ACCOUNT_CREATION_NAME_V2: '/seeker/sc/v2/account-creation/name',
  ACCOUNT_CREATION_PASSWORD_V2: '/seeker/sc/v2/account-creation/password',
});
export const SEEKER_IN_FACILITY_ROUTES = Object.freeze({
  CARE_TRUST: '/seeker/sc/in-facility/care-trust',
  WHO_NEEDS_CARE: '/seeker/sc/in-facility/who-needs-care',
  DESCRIBE_LOVED_ONE: '/seeker/sc/in-facility/describe-loved-one',
  OPTIMIZED_DESCRIBE_LOVED_ONE: '/seeker/sc/in-facility/optimized-describe-loved-one',
  HELP_TYPE: '/seeker/sc/in-facility/help-type',
  LOCATION: '/seeker/sc/in-facility/location',
  LOCATION_OPTIMIZED_FLOW: '/seeker/sc/in-facility/location-optimized-flow',
  RECAP: '/seeker/sc/in-facility/recap',
  ONE_PAGE_ACCOUNT_CREATION: '/seeker/sc/in-facility/one-page-account-creation',
  ACCOUNT_CREATION: '/seeker/sc/in-facility/account-creation',
  ACCOUNT_CREATION_DETAILS: '/seeker/sc/in-facility/account-creation/details',
  ACCOUNT_CREATION_RELATIONSHIP: '/seeker/sc/in-facility/account-creation/relationship',
  ACCOUNT_CREATION_PASSWORD: '/seeker/sc/in-facility/account-creation/password',
  COMMUNITY_LIST: '/seeker/sc/in-facility/community-list',
  AMENITIES: '/seeker/sc/in-facility/amenities',
  PAYMENT_TYPE: '/seeker/sc/in-facility/payment-type',
  PAYMENT_QUESTIONNAIRE: '/seeker/sc/in-facility/payment-questionnaire',
  OPTIONS: '/seeker/sc/in-facility/options',
  CARING_LEADS: '/seeker/sc/in-facility/caring-leads',
  PAYOFF: '/seeker/sc/in-facility/payoff',
  URGENCY: '/seeker/sc/in-facility/urgency',
  // POST-ENROLLMENT flow routes
  NURSING_OPTIONS: '/seeker/sc/in-facility/nursing-options',
  RECOMMENDED_ASSISTED: '/seeker/sc/in-facility/recommended-facility-assisted',
  RECOMMENDED_INDEPENDENT: '/seeker/sc/in-facility/recommended-facility-independent',
  RECOMMENDED_MEMORY_CARE: '/seeker/sc/in-facility/recommended-facility-memory-care',
  RECOMMENDED_NURSING_HOME: '/seeker/sc/in-facility/recommended-facility-nursing-home',
  RECOMMENDED_NURSING_HOME_IN_FACILITY:
    '/seeker/sc/in-facility/recommended-facility-nursing-home-in-facility',
  NO_INVENTORY: '/seeker/sc/in-facility/no-inventory',
  NO_COMMUNITIES_BY_COVERING_COST: '/seeker/sc/in-facility/no-communities-by-covering-cost',
  SENIOR_LIVING_OPTIONS: '/seeker/sc/in-facility/senior-living-options',
  RELATIONSHIP: '/seeker/sc/in-facility/relationship',
});
export const SEEKER_LEAD_CONNECT_ROUTES = Object.freeze({
  CAREGIVER_PROFILE: '/seeker/sc/lc/caregiver-profile',
  RECAP: '/seeker/sc/lc/recap',
  UPGRADE_OR_SKIP: '/seeker/sc/lc/upgrade-or-skip',
  SKIP_FOR_NOW: '/seeker/sc/lc/skip-for-now',
  MESSAGE_SENT: '/seeker/sc/lc/message-sent',
});
export const SEEKER_CC_LEAD_CONNECT_ROUTES = Object.freeze({
  CAREGIVER_LIST: '/seeker/cc/lc/caregiver-list',
  SKIP_FOR_NOW: '/',
  UPGRADE_AND_MESSAGE: '/seeker/cc/lc/upgrade-and-message',
});
export const PROVIDER_ROUTES = Object.freeze({
  INDEX: '/provider/sc',
  ZIP: '/provider/sc/zip',
  ACCOUNT_CREATION: '/provider/sc/account-creation',
  ACCOUNT_CREATED: '/provider/sc/account-created',
  AGE_RESTRICTION: '/provider/sc/age-restriction',
  TYPE_SPECIFIC: '/provider/sc/type-specific',
  EXPERIENCE_LEVEL: '/provider/sc/experience-level',
  PROFILE: '/provider/sc/profile',
  PAY_RANGE: '/provider/sc/pay-range',
  JOB_TYPE: '/provider/sc/job-type',
  HEADLINE_BIO: '/provider/sc/headline-bio',
  PHOTO: '/provider/sc/photo',
  JOBS_MATCHING: '/provider/sc/jobs-matching',
  AVAILABILITY: '/provider/sc/availability',
});
export const PROVIDER_CHILD_CARE_ROUTES = Object.freeze({
  INDEX: '/provider/cc',
  PREFERENCES: '/provider/cc/preferences',
  STEPS: '/provider/cc/steps',
  JOBS_MATCHING: '/provider/cc/jobs-matching',
  JOB_TYPES: '/provider/cc/job-types',
  LOCATION: '/provider/cc/location',
  ACCOUNT: '/provider/cc/account',
  PHOTO: '/provider/cc/photo',
  JOBS: '/provider/cc/jobs',
  AVAILABILITY: '/provider/cc/availability',
  PROFILE: '/provider/cc/profile',
  BIO: '/provider/cc/bio',
  APP_DOWNLOAD: '/provider/cc/app-download',
  WELCOME_BACK: '/provider/cc/welcome-back',
  RATE_CARD: '/swf/ccNonFGRateCardOptimizedFlow',
});

export const PROVIDER_MULTI_VERTICAL_ROUTES = Object.freeze({
  INDEX: '/provider/mv',
  LOCATION: '/provider/mv/location',
  ACCOUNT: '/provider/mv/account',
  PETCARE_PREFERENCES: '/provider/mv/petcare-preferences',
  PREFERENCES: '/provider/mv/preferences',
  SERVICES: '/provider/mv/services-selection',
  HOURLY_RATE: {
    INDEX: '/provider/mv/hourly-rate',
    HOUSEKEEPING: '/provider/mv/hourly-rate/housekeeping',
    TUTORING: '/provider/mv/hourly-rate/tutoring',
    SENIOR_CARE: '/provider/mv/hourly-rate/senior-care',
  },
  RATE_CARD: '/swf/PTARateCardResponsiveFlow',
  APP_DOWNLOAD: '/provider/mv/app-download',
});

export const SEEKER_CHILD_CARE_ROUTES = Object.freeze({
  INDEX: '/seeker/cc',
  CARE_LOCATION: '/seeker/cc/care-location',
  CARE_DATE: '/seeker/cc/v2/care-date',
  CARE_KIND: '/seeker/cc/v2/care-kind',
  CARE_WHO: '/seeker/cc/v2/care-who',
  CARE_MULTI_VERTICAL: '/seeker/cc/v2/care-multi-vertical',
  ADDITIONAL_SUPPORT: '/seeker/cc/v2/additional-support',
  ACCOUNT_CREATION_EMAIL: '/seeker/cc/v2/account-creation/email',
  ACCOUNT_CREATION_NAME: '/seeker/cc/v2/account-creation/name',
  ACCOUNT_PASSWORD: '/seeker/cc/v2/account-creation/password',
  ACCOUNT_CREATION_CONFIRMATION: '/seeker/cc/account-confirmation',
  ACCOUNT_CREATION: '/seeker/cc/account-creation',
  ACCOUNT_CREATION_DETAILS: '/seeker/cc/account-creation/details',
  RECAP: '/seeker/cc/recap',
});

export const SEEKER_HOUSEKEEPING_ROUTES = Object.freeze({
  INDEX: '/seeker/hk',
  HOUSEKEEPING_DATE: '/seeker/hk/care-date',
  HOUSEKEEPER_WHAT: '/seeker/hk/housekeeper-what',
  ACCOUNT_CREATION_EMAIL: '/seeker/hk/account-creation/email',
  ACCOUNT_CREATION_NAME: '/seeker/hk/account-creation/name',
  ACCOUNT_PASSWORD: '/seeker/hk/account-creation/password',
  WHAT_TASKS: '/seeker/hk/what-tasks',
  RECAP: '/seeker/hk/recap',
  LOCATION: '/seeker/hk/location',
  SPACE: '/seeker/hk/space',
  ABOUT: '/seeker/hk/about',
});

export const SEEKER_DAYCARE_CHILD_CARE_ROUTES = Object.freeze({
  INDEX: '/seeker/cc',
  LOCATION: '/seeker/cc/care-location',
  CARE_DATE: '/seeker/cc/v2/care-date',
  CARE_KIND: '/seeker/cc/v2/care-kind',
  WHO: '/seeker/dc/day-center-who-needs-care',
  FREQUENCY: '/seeker/dc/care-frequency',
  DATE_TIME: '/seeker/dc/care-day-time',
  START_DATE: '/seeker/dc/care-start-date',
  ADDITIONAL_INFORMATION: '/seeker/dc/additional-information',
  MATCH: '/seeker/dc/match-daycare',
  ACCOUNT_PASSWORD: '/seeker/dc/account-creation/password',
  RECOMMENDATIONS: '/seeker/dc/recommendations',
  TOURS_REQUESTED: '/seeker/dc/tours-requested',
  PHONE_NUMBER: '/seeker/dc/phone-number',
  PHONE_VERIFICATION: '/seeker/dc/phone-verification',
  HOW_COST_IMPORTANCE: '/seeker/dc/how-important-is-cost',
  DC_EPI_PRE_RATE_CARD_PATH:
    '/app/ratecard/childcare/pre-rate-card?enrollFlow=true&subVertical=daycare&isEarlyPremiumIntro=true',
});

export const AUTH_ROUTES = Object.freeze({
  LOGOUT: (returnUrl: string) =>
    `/vis/auth/oidc/logout${returnUrl ? `?returnUrl=${encodeURIComponent(returnUrl)}` : ''}`,
  LOGIN: `/vis/auth/login`,
  AUTHERROR: '/auth-error',
  GOOGLE_LOGIN: '/api/id-oidc-proxy/google/login',
  APPLE_LOGIN: '/api/id-oidc-proxy/apple/login',
  ONE_TIME_LINK: '/vis/auth/oneTimeLink',
});

export const LTCG_ROUTES = Object.freeze({
  CONTACT_INFO: '/ltcg/contact-info',
  DETAILS_ABOUT_YOURSELF: '/ltcg/details-about-yourself',
  INSURANCE_CARRIER: '/ltcg/insurance-carrier',
  NO_INSURANCE: '/ltcg/no-insurance',
  ELIGIBLE_POLICY: '/ltcg/eligible-policy',
  POLICY_INELIGIBLE: '/ltcg/policy-ineligible',
  LOCATION_INELIGIBLE: '/ltcg/location-ineligible',
  WHERE: '/ltcg/where',
  WHEN: '/ltcg/when',
  SUCCESS: '/ltcg/success',
});

export const LTCG_INELIGIBLES_ACRONYM_STATES = Object.freeze({
  CA: 'CA',
  IL: 'IL',
  CO: 'CO',
  DE: 'DE',
  LA: 'LA',
  MA: 'MA',
  WI: 'WI',
  PR: 'PR',
});

export const SHORT_ENROLLMENT_ROUTES = Object.freeze({
  INDEX: '/short-enrollment',
  PASSWORD: '/short-enrollment/password',
});

export const FLOWS = Object.freeze({
  SEEKER_IN_FACILITY: {
    name: 'SEEKER_IN_FACILITY',
    path: '/seeker/sc/in-facility',
  },
  SEEKER: {
    name: 'SEEKER',
    path: '/seeker/sc',
  },

  SEEKER_WITH_ADD_ON_VERTICALS: {
    name: 'SEEKER_WITH_ADD_ON_VERTICALS',
    path: '/seeker/sc',
  },
  SEEKER_SENIOR_CARE_V2: {
    name: 'SEEKER_SENIOR_CARE_V2',
    path: '/seeker/sc',
  },
  SEEKER_SENIOR_CARE_SKIP_HELP_TYPE_IN_HOME: {
    name: 'SEEKER_SENIOR_CARE_SKIP_HELP_TYPE_IN_HOME',
    path: '/seeker/sc',
  },
  SEEKER_SENIOR_CARE_SKIP_HELP_TYPE_NOT_SURE: {
    name: 'SEEKER_SENIOR_CARE_SKIP_HELP_TYPE_NOT_SURE',
    path: '/seeker/sc',
  },
  SEEKER_INSTANT_BOOK_SHORT: {
    name: 'SEEKER_INSTANT_BOOK_SHORT',
    path: '/seeker/ib/short',
  },
  SEEKER_INSTANT_BOOK_SHORT_MATCH: {
    name: 'SEEKER_INSTANT_BOOK_SHORT_MATCH',
    path: '/seeker/ib/match',
  },
  SEEKER_INSTANT_BOOK: {
    name: 'SEEKER_INSTANT_BOOK',
    path: '/seeker/ib',
  },
  SEEKER_INSTANT_BOOK_PET_CARE: {
    name: 'SEEKER_INSTANT_BOOK_PET_CARE',
    path: '/seeker/ib-pc',
  },
  SEEKER_CHILD_CARE: {
    name: 'SEEKER_CHILD_CARE',
    path: '/seeker/cc',
  },
  SEEKER_CHILD_CARE_WITH_ADD_ON_VERTICALS: {
    name: 'SEEKER_CHILD_CARE_WITH_ADD_ON_VERTICALS',
    path: '/seeker/cc',
  },

  SEEKER_CHILD_CARE_SKIP_CARE_KIND_SEO: {
    name: 'SEEKER_CHILD_CARE_SKIP_CARE_KIND_SEO',
    path: '/seeker/cc',
  },

  SEEKER_DAYCARE_CHILD_CARE: {
    name: 'SEEKER_DAYCARE_CHILD_CARE',
    path: '/seeker/dc',
  },
  SEEKER_DAYCARE_CHILD_CARE_REDUCED: {
    name: 'SEEKER_DAYCARE_CHILD_CARE_REDUCED',
    path: '/seeker/dc',
  },
  SEEKER_DAYCARE_CARE_KIND: {
    name: 'SEEKER_DAYCARE_CARE_KIND',
    path: '/seeker/dc',
  },
  PROVIDER: {
    name: 'PROVIDER',
    path: '/provider/sc',
  },
  PROVIDER_MULTI_VERTICAL: {
    name: 'PROVIDER_MULTI_VERTICAL',
    path: '/provider/mv',
  },
  CHILD_CARE_PROVIDER: {
    name: 'CHILD_CARE_PROVIDER',
    path: '/provider/cc',
  },
  SEEKER_HOUSEKEEPING: {
    name: 'SEEKER_HOUSEKEEPING',
    path: '/seeker/hk',
  },
  SEEKER_HOUSEKEEPING_FROM_VHP: {
    name: 'SEEKER_HOUSEKEEPING_FROM_VHP',
    path: '/seeker/hk',
  },
  SEEKER_HOUSEKEEPING_REDESIGN: {
    name: 'SEEKER_HOUSEKEEPING_REDESIGN',
    path: '/seeker/hk',
  },
  SEEKER_PET_CARE: {
    name: 'SEEKER_PET_CARE',
    path: '/seeker/pc',
  },
  SEEKER_PET_CARE_WITH_ADD_ON_VERTICALS: {
    name: 'SEEKER_PET_CARE_WITH_ADD_ON_VERTICALS',
    path: '/seeker/pc',
  },
  SEEKER_PET_CARE_FROM_VHP: {
    name: 'SEEKER_PET_CARE_FROM_VHP',
    path: '/seeker/pc',
  },
  SEEKER_PET_CARE_FROM_VHP_WITH_ADD_ON_VERTICAL: {
    name: 'SEEKER_PET_CARE_FROM_VHP_WITH_ADD_ON_VERTICALS',
    path: '/seeker/pc',
  },
  SEEKER_TUTORING: {
    name: 'SEEKER_TUTORING',
    path: '/seeker/tu',
  },
  SEEKER_TUTORING_WITH_ADD_ON_VERTICALS: {
    name: 'SEEKER_TUTORING_WITH_ADD_ON_VERTICALS',
    path: '/seeker/tu',
  },
  SEEKER_TUTORING_FROM_VHP: {
    name: 'SEEKER_TUTORING_FROM_VHP',
    path: '/seeker/tu',
  },
  SEEKER_TUTORING_FROM_VHP_WITH_ADD_ON_VERTICALS: {
    name: 'SEEKER_TUTORING_FROM_VHP_WITH_ADD_ON_VERTICALS',
    path: '/seeker/tu',
  },
  LTCG: {
    name: 'LTCG',
    path: '/ltcg',
  },
});

export const SEEKER_PET_CARE_ROUTES = Object.freeze({
  INDEX: '/seeker/pc',
  CARE_DATE: '/seeker/pc/care-date',
  ABOUT_PETS: '/seeker/pc/about-pets',
  SERVICE_TYPE: '/seeker/pc/service-type',
  LOCATION: '/seeker/pc/location',
  MULTI_VERTICAL: '/seeker/pc/care-multi-vertical',
  RECAP: '/seeker/pc/recap',
  ACCOUNT_CREATION_EMAIL: '/seeker/pc/account-creation/email',
  ACCOUNT_CREATION_NAME: '/seeker/pc/account-creation/name',
  ACCOUNT_PASSWORD: '/seeker/pc/account-creation/password',
});

export const SEEKER_TUTORING_ROUTES = Object.freeze({
  INDEX: '/seeker/tu',
  WHAT_LEVEL: '/seeker/tu/what-level',
  CARE_DATE: '/seeker/tu/care-date',
  WHICH_SUBJECTS: '/seeker/tu/which-subjects',
  LOCATION: '/seeker/tu/location',
  RECAP: '/seeker/tu/recap',
  VIRTUAL_OR_IN_PERSON: '/seeker/tu/virtual-or-in-person',
  MULTI_VERTICAL: '/seeker/tu/care-multi-vertical',
  ACCOUNT_CREATION_EMAIL: '/seeker/tu/account-creation/email',
  ACCOUNT_CREATION_NAME: '/seeker/tu/account-creation/name',
  ACCOUNT_PASSWORD: '/seeker/tu/account-creation/password',
});

export const SEEKER_SPLIT_ACCOUNT_DC = Object.freeze({
  EMAIL: '/seeker/dc/account-creation/email',
  NAME: '/seeker/dc/account-creation/name',
  PHONE: 'seeker/dc/account-creation/phone',
});

export const SEEKER_INSTANT_BOOK_ROUTES = Object.freeze({
  WHO: '/seeker/ib/care-who',
  WHAT_DAY_AND_TIME: '/seeker/ib/what-day-and-time',
  ADDRESS: '/seeker/ib/address',
  PAY_FOR_CARE: '/seeker/ib/pay-for-care',
  IS_HOME_ADDRESS: '/seeker/ib/is-home-address',
  HOME_ADDRESS: '/seeker/ib/home-address',
  NAME: '/seeker/ib/name',
  RECAP: '/seeker/ib/recap',
  LAST_STEP: '/seeker/ib/last-step',
});

export const SEEKER_INSTANT_BOOK_PET_CARE_ROUTES = Object.freeze({
  INDEX: '/seeker/ib-pc',
  CARE_NEEDS: '/seeker/ib-pc/care-needs',
  PET_DETAILS: '/seeker/ib-pc/pet-details',
  RECAP: '/seeker/ib-pc/recap',
  ACCOUNT_CREATION_EMAIL: '/seeker/ib-pc/account-creation/email',
  ACCOUNT_CREATION_NAME: '/seeker/ib-pc/account-creation/name',
  ACCOUNT_PASSWORD: '/seeker/ib-pc/account-creation/password',
});

export const SEEKER_INSTANT_BOOK_SHORT_ROUTES = Object.freeze({
  EMAIL: '/seeker/ib/short/email',
  NAME: '/seeker/ib/short/name',
});

export const SEEKER_INSTANT_BOOK_SHORT_MATCH_ROUTES = Object.freeze({
  EMAIL: '/seeker/ib/match/email',
  NAME: '/seeker/ib/match/name',
  NEEDS: '/seeker/ib/match/needs',
  PROVIDER_MATCHES: '/seeker/ib/match/provider-matches',
});

// key values aligned with ServiceType values (from enrollment-mfe/src/__generated__/globalTypes.ts)
export const VERTICALS_NAMES = Object.freeze({
  CHILD_CARE: 'Childcare',
  SENIOR_CARE: 'Seniorcare',
  HOUSEKEEPING: 'Housekeeping',
  PET_CARE: 'Petcare',
  TUTORING: 'Tutoring',
  MULTI_VERTICAL: 'MultiVertical',
});

export const VERTICALS_SELECT_LABELS = Object.freeze({
  CC: 'Child care',
  SC: 'Senior care',
  HK: 'Housekeeping',
  PC: 'Pet care',
  TU: 'Tutoring',
  DC: 'Daycare',
});

export const VERTICAL_CAREGIVERS: { [key: string]: string } = Object.freeze({
  [ServiceType.HOUSEKEEPING]: 'housekeepers',
  [ServiceType.PET_CARE]: 'pet caregivers',
  [ServiceType.TUTORING]: 'tutors',
  [ServiceType.CHILD_CARE]: 'caregivers',
  [ServiceType.SENIOR_CARE]: 'caregivers',
});

export const VERTICALS_NAMES_TO_ABBREVIATION = Object.freeze({
  [VERTICALS_NAMES.CHILD_CARE]: 'CC',
  [VERTICALS_NAMES.MULTI_VERTICAL]: 'MV',
  [VERTICALS_NAMES.SENIOR_CARE]: 'SC',
  [VERTICALS_NAMES.HOUSEKEEPING]: 'HK',
  [VERTICALS_NAMES.PET_CARE]: 'PC',
  [VERTICALS_NAMES.TUTORING]: 'TU',
  Daycare: 'DC',
});

interface IFlowRoutes {
  [key: string]: {
    [key: string]: number;
  };
}

// order matters so keep these in order
export const FLOW_ROUTES_AND_STEP_NUMBERS: IFlowRoutes = {
  SEEKER: {
    [SEEKER_ROUTES.INDEX]: 1,
    [SEEKER_ROUTES.HELP_TYPE]: 2,
    [SEEKER_ROUTES.LOCATION]: 3,
    [SEEKER_ROUTES.RECAP]: 3,
    [SEEKER_ROUTES.ACCOUNT_CREATION]: 4,
    [SEEKER_ROUTES.ACCOUNT_CREATION_NAME]: 5,
    [SEEKER_ROUTES.ACCOUNT_CREATION_PASSWORD]: 6,
  },

  SEEKER_SENIOR_CARE_SKIP_HELP_TYPE_IN_HOME: {
    [SEEKER_ROUTES.INDEX]: 1,
    [SEEKER_ROUTES.LOCATION]: 2,
    [SEEKER_ROUTES.RECAP]: 2,
    [SEEKER_ROUTES.ACCOUNT_CREATION_V2]: 3,
    [SEEKER_ROUTES.ACCOUNT_CREATION_NAME_V2]: 4,
    [SEEKER_ROUTES.ACCOUNT_CREATION_PASSWORD_V2]: 5,
  },

  SEEKER_SENIOR_CARE_SKIP_HELP_TYPE_NOT_SURE: {
    [SEEKER_ROUTES.INDEX]: 1,
    [SEEKER_ROUTES.LOCATION]: 2,
    [SEEKER_ROUTES.RECAP]: 2,
    [SEEKER_ROUTES.ACCOUNT_CREATION]: 3,
    [SEEKER_ROUTES.ACCOUNT_CREATION_NAME]: 4,
    [SEEKER_ROUTES.ACCOUNT_CREATION_PASSWORD]: 5,
  },

  SEEKER_WITH_ADD_ON_VERTICALS: {
    [SEEKER_ROUTES.INDEX]: 1,
    [SEEKER_ROUTES.HELP_TYPE]: 2,
    [SEEKER_ROUTES.LOCATION]: 3,
    [SEEKER_ROUTES.MULTI_VERTICAL]: 4,
    [SEEKER_ROUTES.RECAP]: 4,
    [SEEKER_ROUTES.ACCOUNT_CREATION_V2]: 5,
    [SEEKER_ROUTES.ACCOUNT_CREATION_NAME_V2]: 6,
    [SEEKER_ROUTES.ACCOUNT_CREATION_PASSWORD_V2]: 7,
  },

  SEEKER_SENIOR_CARE_V2: {
    [SEEKER_ROUTES.INDEX]: 1,
    [SEEKER_ROUTES.HELP_TYPE]: 2,
    [SEEKER_ROUTES.LOCATION]: 3,
    [SEEKER_ROUTES.RECAP]: 3,
    [SEEKER_ROUTES.ACCOUNT_CREATION_V2]: 4,
    [SEEKER_ROUTES.ACCOUNT_CREATION_NAME_V2]: 5,
    [SEEKER_ROUTES.ACCOUNT_CREATION_PASSWORD_V2]: 6,
  },

  SEEKER_IN_FACILITY: {
    [SEEKER_ROUTES.INDEX]: 1,
    [SEEKER_IN_FACILITY_ROUTES.CARE_TRUST]: 1,
    [SEEKER_IN_FACILITY_ROUTES.LOCATION_OPTIMIZED_FLOW]: 1, // enrollment-mfe-in-facility-enrollment-recommendations-and-flow-optimizations
    [SEEKER_IN_FACILITY_ROUTES.WHO_NEEDS_CARE]: 2,
    [SEEKER_IN_FACILITY_ROUTES.URGENCY]: 2, // used in post-enrollment flow
    [SEEKER_IN_FACILITY_ROUTES.DESCRIBE_LOVED_ONE]: 3,
    [SEEKER_IN_FACILITY_ROUTES.HELP_TYPE]: 4,
    [SEEKER_IN_FACILITY_ROUTES.NURSING_OPTIONS]: 4, // used in post-enrollment flow
    [SEEKER_IN_FACILITY_ROUTES.LOCATION]: 5,
    [SEEKER_IN_FACILITY_ROUTES.OPTIMIZED_DESCRIBE_LOVED_ONE]: 5, // used in optimized-flow FF
    [SEEKER_IN_FACILITY_ROUTES.RECOMMENDED_ASSISTED]: 5, // used in post-enrollment flow
    [SEEKER_IN_FACILITY_ROUTES.RECOMMENDED_INDEPENDENT]: 5, // used in post-enrollment flow
    [SEEKER_IN_FACILITY_ROUTES.RECOMMENDED_MEMORY_CARE]: 5, // used in post-enrollment flow
    [SEEKER_IN_FACILITY_ROUTES.RECOMMENDED_NURSING_HOME]: 5, // used in post-enrollment flow
    [SEEKER_IN_FACILITY_ROUTES.SENIOR_LIVING_OPTIONS]: 5, // used in post-enrollment flow
    [SEEKER_IN_FACILITY_ROUTES.PAYMENT_TYPE]: 6,
    [SEEKER_IN_FACILITY_ROUTES.AMENITIES]: 6, // enrollment-mfe-in-facility-enrollment-recommendations-and-flow-optimizations
    [SEEKER_IN_FACILITY_ROUTES.PAYMENT_QUESTIONNAIRE]: 6,
    [SEEKER_IN_FACILITY_ROUTES.RELATIONSHIP]: 7, // used in enrollment-mfe-in-facility-flow-optimization
    [SEEKER_IN_FACILITY_ROUTES.RECAP]: 8,
    [SEEKER_IN_FACILITY_ROUTES.ACCOUNT_CREATION]: 9,
    [SEEKER_IN_FACILITY_ROUTES.ACCOUNT_CREATION_DETAILS]: 10,
    [SEEKER_IN_FACILITY_ROUTES.ACCOUNT_CREATION_RELATIONSHIP]: 11, // used in enrollment-mfe-in-facility-flow-optimization
    [SEEKER_IN_FACILITY_ROUTES.ACCOUNT_CREATION_PASSWORD]: 12,
    [SEEKER_IN_FACILITY_ROUTES.OPTIONS]: 14,
    [SEEKER_IN_FACILITY_ROUTES.CARING_LEADS]: 15,
    [SEEKER_IN_FACILITY_ROUTES.COMMUNITY_LIST]: 15,
    [SEEKER_IN_FACILITY_ROUTES.PAYOFF]: 16,
    [SEEKER_IN_FACILITY_ROUTES.NO_INVENTORY]: 17, // used in post-enrollment flow
    [SEEKER_IN_FACILITY_ROUTES.NO_COMMUNITIES_BY_COVERING_COST]: 17, // used in post-enrollment flow
  },

  SEEKER_INSTANT_BOOK_SHORT: {
    [SEEKER_INSTANT_BOOK_SHORT_ROUTES.EMAIL]: 4,
    [SEEKER_INSTANT_BOOK_SHORT_ROUTES.NAME]: 5,
  },

  SEEKER_INSTANT_BOOK_SHORT_MATCH: {
    [SEEKER_INSTANT_BOOK_SHORT_MATCH_ROUTES.NEEDS]: 4,
    [SEEKER_INSTANT_BOOK_SHORT_MATCH_ROUTES.PROVIDER_MATCHES]: 5,
    [SEEKER_INSTANT_BOOK_SHORT_MATCH_ROUTES.EMAIL]: 6,
    [SEEKER_INSTANT_BOOK_SHORT_MATCH_ROUTES.NAME]: 7,
  },

  SEEKER_INSTANT_BOOK: {
    [SEEKER_INSTANT_BOOK_ROUTES.WHO]: 4,
    [SEEKER_INSTANT_BOOK_ROUTES.WHAT_DAY_AND_TIME]: 5,
    [SEEKER_INSTANT_BOOK_ROUTES.PAY_FOR_CARE]: 6,
    [SEEKER_INSTANT_BOOK_ROUTES.ADDRESS]: 7,
    [SEEKER_INSTANT_BOOK_ROUTES.IS_HOME_ADDRESS]: 8,
    [SEEKER_INSTANT_BOOK_ROUTES.HOME_ADDRESS]: 9,
    [SEEKER_INSTANT_BOOK_ROUTES.NAME]: 9,
    [SEEKER_INSTANT_BOOK_ROUTES.LAST_STEP]: 10,
  },

  SEEKER_CHILD_CARE: {
    [SEEKER_CHILD_CARE_ROUTES.CARE_LOCATION]: 1,
    [SEEKER_CHILD_CARE_ROUTES.INDEX]: 1,
    [SEEKER_CHILD_CARE_ROUTES.CARE_DATE]: 2,
    [SEEKER_CHILD_CARE_ROUTES.CARE_KIND]: 3,
    [SEEKER_CHILD_CARE_ROUTES.CARE_WHO]: 4,
    [SEEKER_CHILD_CARE_ROUTES.ADDITIONAL_SUPPORT]: 5,
    [SEEKER_CHILD_CARE_ROUTES.ACCOUNT_CREATION_EMAIL]: 6,
    [SEEKER_CHILD_CARE_ROUTES.ACCOUNT_CREATION_NAME]: 7,
    [SEEKER_CHILD_CARE_ROUTES.ACCOUNT_PASSWORD]: 8,
  },

  SEEKER_CHILD_CARE_WITH_ADD_ON_VERTICALS: {
    [SEEKER_CHILD_CARE_ROUTES.CARE_LOCATION]: 1,
    [SEEKER_CHILD_CARE_ROUTES.INDEX]: 1,
    [SEEKER_CHILD_CARE_ROUTES.CARE_DATE]: 2,
    [SEEKER_CHILD_CARE_ROUTES.CARE_KIND]: 3,
    [SEEKER_CHILD_CARE_ROUTES.CARE_WHO]: 4,
    [SEEKER_CHILD_CARE_ROUTES.CARE_MULTI_VERTICAL]: 5,
    [SEEKER_CHILD_CARE_ROUTES.ADDITIONAL_SUPPORT]: 6,
    [SEEKER_CHILD_CARE_ROUTES.ACCOUNT_CREATION_EMAIL]: 7,
    [SEEKER_CHILD_CARE_ROUTES.ACCOUNT_CREATION_NAME]: 8,
    [SEEKER_CHILD_CARE_ROUTES.ACCOUNT_PASSWORD]: 9,
  },

  SEEKER_CHILD_CARE_SKIP_CARE_KIND_SEO: {
    [SEEKER_CHILD_CARE_ROUTES.CARE_LOCATION]: 1,
    [SEEKER_CHILD_CARE_ROUTES.INDEX]: 1,
    [SEEKER_CHILD_CARE_ROUTES.CARE_DATE]: 2,
    [SEEKER_CHILD_CARE_ROUTES.CARE_WHO]: 3,
    [SEEKER_CHILD_CARE_ROUTES.RECAP]: 4,
    [SEEKER_CHILD_CARE_ROUTES.ACCOUNT_CREATION_EMAIL]: 5,
    [SEEKER_CHILD_CARE_ROUTES.ACCOUNT_CREATION_NAME]: 6,
    [SEEKER_CHILD_CARE_ROUTES.ACCOUNT_PASSWORD]: 7,
  },

  SEEKER_HOUSEKEEPING: {
    [SEEKER_HOUSEKEEPING_ROUTES.INDEX]: 1,
    [SEEKER_HOUSEKEEPING_ROUTES.HOUSEKEEPING_DATE]: 1,
    [SEEKER_HOUSEKEEPING_ROUTES.HOUSEKEEPER_WHAT]: 2,
    [SEEKER_HOUSEKEEPING_ROUTES.WHAT_TASKS]: 3,
    [SEEKER_HOUSEKEEPING_ROUTES.LOCATION]: 4,
    [SEEKER_HOUSEKEEPING_ROUTES.ACCOUNT_CREATION_EMAIL]: 5,
    [SEEKER_HOUSEKEEPING_ROUTES.ACCOUNT_CREATION_NAME]: 6,
    [SEEKER_HOUSEKEEPING_ROUTES.ACCOUNT_PASSWORD]: 7,
  },

  SEEKER_HOUSEKEEPING_FROM_VHP: {
    [SEEKER_HOUSEKEEPING_ROUTES.INDEX]: 1,
    [SEEKER_HOUSEKEEPING_ROUTES.HOUSEKEEPING_DATE]: 1,
    [SEEKER_HOUSEKEEPING_ROUTES.HOUSEKEEPER_WHAT]: 2,
    [SEEKER_HOUSEKEEPING_ROUTES.WHAT_TASKS]: 3,
    [SEEKER_HOUSEKEEPING_ROUTES.ACCOUNT_CREATION_EMAIL]: 4,
    [SEEKER_HOUSEKEEPING_ROUTES.ACCOUNT_CREATION_NAME]: 5,
    [SEEKER_HOUSEKEEPING_ROUTES.ACCOUNT_PASSWORD]: 6,
  },

  SEEKER_HOUSEKEEPING_REDESIGN: {
    [SEEKER_HOUSEKEEPING_ROUTES.INDEX]: 1,
    [SEEKER_HOUSEKEEPING_ROUTES.SPACE]: 2,
    [SEEKER_HOUSEKEEPING_ROUTES.ABOUT]: 3,
    [SEEKER_HOUSEKEEPING_ROUTES.LOCATION]: 4,
    [SEEKER_HOUSEKEEPING_ROUTES.RECAP]: 5,
    [SEEKER_HOUSEKEEPING_ROUTES.ACCOUNT_CREATION_EMAIL]: 6,
    [SEEKER_HOUSEKEEPING_ROUTES.ACCOUNT_CREATION_NAME]: 7,
    [SEEKER_HOUSEKEEPING_ROUTES.ACCOUNT_PASSWORD]: 8,
  },

  SEEKER_PET_CARE: {
    [SEEKER_PET_CARE_ROUTES.INDEX]: 1,
    [SEEKER_PET_CARE_ROUTES.CARE_DATE]: 1,
    [SEEKER_PET_CARE_ROUTES.ABOUT_PETS]: 2,
    [SEEKER_PET_CARE_ROUTES.SERVICE_TYPE]: 3,
    [SEEKER_PET_CARE_ROUTES.LOCATION]: 4,
    [SEEKER_PET_CARE_ROUTES.RECAP]: 4,
    [SEEKER_PET_CARE_ROUTES.ACCOUNT_CREATION_EMAIL]: 5,
    [SEEKER_PET_CARE_ROUTES.ACCOUNT_CREATION_NAME]: 6,
    [SEEKER_PET_CARE_ROUTES.ACCOUNT_PASSWORD]: 7,
  },

  SEEKER_PET_CARE_WITH_ADD_ON_VERTICALS: {
    [SEEKER_PET_CARE_ROUTES.INDEX]: 1,
    [SEEKER_PET_CARE_ROUTES.ABOUT_PETS]: 2,
    [SEEKER_PET_CARE_ROUTES.SERVICE_TYPE]: 3,
    [SEEKER_PET_CARE_ROUTES.LOCATION]: 4,
    [SEEKER_PET_CARE_ROUTES.MULTI_VERTICAL]: 5,
    [SEEKER_PET_CARE_ROUTES.RECAP]: 5,
    [SEEKER_PET_CARE_ROUTES.ACCOUNT_CREATION_EMAIL]: 6,
    [SEEKER_PET_CARE_ROUTES.ACCOUNT_CREATION_NAME]: 7,
    [SEEKER_PET_CARE_ROUTES.ACCOUNT_PASSWORD]: 8,
  },

  SEEKER_PET_CARE_FROM_VHP: {
    [SEEKER_PET_CARE_ROUTES.INDEX]: 1,
    [SEEKER_PET_CARE_ROUTES.CARE_DATE]: 1,
    [SEEKER_PET_CARE_ROUTES.ABOUT_PETS]: 2,
    [SEEKER_PET_CARE_ROUTES.SERVICE_TYPE]: 3,
    [SEEKER_PET_CARE_ROUTES.RECAP]: 3,
    [SEEKER_PET_CARE_ROUTES.ACCOUNT_CREATION_EMAIL]: 4,
    [SEEKER_PET_CARE_ROUTES.ACCOUNT_CREATION_NAME]: 5,
    [SEEKER_PET_CARE_ROUTES.ACCOUNT_PASSWORD]: 6,
  },

  SEEKER_PET_CARE_FROM_VHP_WITH_ADD_ON_VERTICALS: {
    [SEEKER_PET_CARE_ROUTES.INDEX]: 1,
    [SEEKER_PET_CARE_ROUTES.ABOUT_PETS]: 2,
    [SEEKER_PET_CARE_ROUTES.SERVICE_TYPE]: 3,
    [SEEKER_PET_CARE_ROUTES.MULTI_VERTICAL]: 4,
    [SEEKER_PET_CARE_ROUTES.RECAP]: 4,
    [SEEKER_PET_CARE_ROUTES.ACCOUNT_CREATION_EMAIL]: 5,
    [SEEKER_PET_CARE_ROUTES.ACCOUNT_CREATION_NAME]: 6,
    [SEEKER_PET_CARE_ROUTES.ACCOUNT_PASSWORD]: 7,
  },

  SEEKER_DAYCARE_CHILD_CARE: {
    [SEEKER_DAYCARE_CHILD_CARE_ROUTES.LOCATION]: 1,
    [SEEKER_DAYCARE_CHILD_CARE_ROUTES.CARE_DATE]: 2,
    [SEEKER_DAYCARE_CHILD_CARE_ROUTES.CARE_KIND]: 3,
    [SEEKER_DAYCARE_CHILD_CARE_ROUTES.WHO]: 4,
    [SEEKER_DAYCARE_CHILD_CARE_ROUTES.FREQUENCY]: 5,
    [SEEKER_DAYCARE_CHILD_CARE_ROUTES.DATE_TIME]: 6,
    [SEEKER_DAYCARE_CHILD_CARE_ROUTES.START_DATE]: 7,
    [SEEKER_DAYCARE_CHILD_CARE_ROUTES.ADDITIONAL_INFORMATION]: 8,
    [SEEKER_DAYCARE_CHILD_CARE_ROUTES.MATCH]: 9,
    [SEEKER_SPLIT_ACCOUNT_DC.EMAIL]: 10,
    [SEEKER_SPLIT_ACCOUNT_DC.NAME]: 11,
    [SEEKER_DAYCARE_CHILD_CARE_ROUTES.ACCOUNT_PASSWORD]: 12,
    [SEEKER_DAYCARE_CHILD_CARE_ROUTES.RECOMMENDATIONS]: 12,
  },

  SEEKER_DAYCARE_CHILD_CARE_REDUCED: {
    [SEEKER_DAYCARE_CHILD_CARE_ROUTES.LOCATION]: 1,
    [SEEKER_DAYCARE_CHILD_CARE_ROUTES.INDEX]: 1,
    [SEEKER_DAYCARE_CHILD_CARE_ROUTES.CARE_DATE]: 2,
    [SEEKER_DAYCARE_CHILD_CARE_ROUTES.CARE_KIND]: 3,
    [SEEKER_DAYCARE_CHILD_CARE_ROUTES.WHO]: 4,
    [SEEKER_DAYCARE_CHILD_CARE_ROUTES.FREQUENCY]: 5,
    [SEEKER_DAYCARE_CHILD_CARE_ROUTES.MATCH]: 6,
    [SEEKER_SPLIT_ACCOUNT_DC.EMAIL]: 7,
    [SEEKER_SPLIT_ACCOUNT_DC.NAME]: 8,
    [SEEKER_DAYCARE_CHILD_CARE_ROUTES.PHONE_NUMBER]: 9,
    [SEEKER_DAYCARE_CHILD_CARE_ROUTES.PHONE_VERIFICATION]: 9,
    [SEEKER_DAYCARE_CHILD_CARE_ROUTES.HOW_COST_IMPORTANCE]: 10,
    [SEEKER_DAYCARE_CHILD_CARE_ROUTES.DC_EPI_PRE_RATE_CARD_PATH]: 10,
    [SEEKER_DAYCARE_CHILD_CARE_ROUTES.ACCOUNT_PASSWORD]: 11,
    [SEEKER_DAYCARE_CHILD_CARE_ROUTES.RECOMMENDATIONS]: 11,
  },

  SEEKER_DAYCARE_CARE_KIND: {
    [SEEKER_DAYCARE_CHILD_CARE_ROUTES.LOCATION]: 1,
    [SEEKER_DAYCARE_CHILD_CARE_ROUTES.INDEX]: 1,
    [SEEKER_DAYCARE_CHILD_CARE_ROUTES.CARE_KIND]: 2,
    [SEEKER_DAYCARE_CHILD_CARE_ROUTES.CARE_DATE]: 3,
    [SEEKER_DAYCARE_CHILD_CARE_ROUTES.WHO]: 4,
    [SEEKER_DAYCARE_CHILD_CARE_ROUTES.FREQUENCY]: 5,
    [SEEKER_DAYCARE_CHILD_CARE_ROUTES.MATCH]: 6,
    [SEEKER_SPLIT_ACCOUNT_DC.EMAIL]: 7,
    [SEEKER_SPLIT_ACCOUNT_DC.NAME]: 8,
    [SEEKER_DAYCARE_CHILD_CARE_ROUTES.PHONE_NUMBER]: 9,
    [SEEKER_DAYCARE_CHILD_CARE_ROUTES.PHONE_VERIFICATION]: 9,
    [SEEKER_DAYCARE_CHILD_CARE_ROUTES.HOW_COST_IMPORTANCE]: 10,
    [SEEKER_DAYCARE_CHILD_CARE_ROUTES.DC_EPI_PRE_RATE_CARD_PATH]: 10,
    [SEEKER_DAYCARE_CHILD_CARE_ROUTES.ACCOUNT_PASSWORD]: 11,
    [SEEKER_DAYCARE_CHILD_CARE_ROUTES.RECOMMENDATIONS]: 11,
  },

  SEEKER_TUTORING: {
    [SEEKER_TUTORING_ROUTES.INDEX]: 1,
    [SEEKER_TUTORING_ROUTES.WHAT_LEVEL]: 1,
    [SEEKER_TUTORING_ROUTES.CARE_DATE]: 2,
    [SEEKER_TUTORING_ROUTES.WHICH_SUBJECTS]: 3,
    [SEEKER_TUTORING_ROUTES.LOCATION]: 4,
    [SEEKER_TUTORING_ROUTES.VIRTUAL_OR_IN_PERSON]: 5,
    [SEEKER_TUTORING_ROUTES.ACCOUNT_CREATION_EMAIL]: 6,
    [SEEKER_TUTORING_ROUTES.ACCOUNT_CREATION_NAME]: 7,
    [SEEKER_TUTORING_ROUTES.ACCOUNT_PASSWORD]: 8,
  },

  SEEKER_TUTORING_FROM_VHP: {
    [SEEKER_TUTORING_ROUTES.INDEX]: 1,
    [SEEKER_TUTORING_ROUTES.WHAT_LEVEL]: 1,
    [SEEKER_TUTORING_ROUTES.CARE_DATE]: 2,
    [SEEKER_TUTORING_ROUTES.WHICH_SUBJECTS]: 3,
    [SEEKER_TUTORING_ROUTES.VIRTUAL_OR_IN_PERSON]: 4,
    [SEEKER_TUTORING_ROUTES.ACCOUNT_CREATION_EMAIL]: 5,
    [SEEKER_TUTORING_ROUTES.ACCOUNT_CREATION_NAME]: 6,
    [SEEKER_TUTORING_ROUTES.ACCOUNT_PASSWORD]: 7,
  },

  SEEKER_TUTORING_WITH_ADD_ON_VERTICALS: {
    [SEEKER_TUTORING_ROUTES.INDEX]: 1,
    [SEEKER_TUTORING_ROUTES.CARE_DATE]: 2,
    [SEEKER_TUTORING_ROUTES.WHICH_SUBJECTS]: 3,
    [SEEKER_TUTORING_ROUTES.LOCATION]: 4,
    [SEEKER_TUTORING_ROUTES.VIRTUAL_OR_IN_PERSON]: 5,
    [SEEKER_TUTORING_ROUTES.MULTI_VERTICAL]: 6,
    [SEEKER_TUTORING_ROUTES.ACCOUNT_CREATION_EMAIL]: 7,
    [SEEKER_TUTORING_ROUTES.ACCOUNT_CREATION_NAME]: 8,
    [SEEKER_TUTORING_ROUTES.ACCOUNT_PASSWORD]: 9,
  },

  SEEKER_TUTORING_FROM_VHP_WITH_ADD_ON_VERTICALS: {
    [SEEKER_TUTORING_ROUTES.INDEX]: 1,
    [SEEKER_TUTORING_ROUTES.CARE_DATE]: 2,
    [SEEKER_TUTORING_ROUTES.WHICH_SUBJECTS]: 3,
    [SEEKER_TUTORING_ROUTES.VIRTUAL_OR_IN_PERSON]: 4,
    [SEEKER_TUTORING_ROUTES.MULTI_VERTICAL]: 5,
    [SEEKER_TUTORING_ROUTES.ACCOUNT_CREATION_EMAIL]: 6,
    [SEEKER_TUTORING_ROUTES.ACCOUNT_CREATION_NAME]: 7,
    [SEEKER_TUTORING_ROUTES.ACCOUNT_PASSWORD]: 8,
  },

  PROVIDER_ACCOUNT_CREATION: {
    [PROVIDER_ROUTES.INDEX]: 1,
    // [PROVIDER_ROUTES.ZIP]: 2,
    [PROVIDER_ROUTES.ACCOUNT_CREATION]: 2,
    [PROVIDER_ROUTES.ACCOUNT_CREATED]: 3,
  },

  PROVIDER_PROFILE_DETAILS: {
    [PROVIDER_ROUTES.INDEX]: 1,
    [PROVIDER_ROUTES.TYPE_SPECIFIC]: 1,
    [PROVIDER_ROUTES.EXPERIENCE_LEVEL]: 2,
    [PROVIDER_ROUTES.PROFILE]: 3,
    [PROVIDER_ROUTES.PAY_RANGE]: 4,
    [PROVIDER_ROUTES.JOB_TYPE]: 5,
    [PROVIDER_ROUTES.AVAILABILITY]: 6,
    [PROVIDER_ROUTES.HEADLINE_BIO]: 7,
    [PROVIDER_ROUTES.PHOTO]: 8,
    [PROVIDER_ROUTES.JOBS_MATCHING]: 9,
  },

  PROVIDER_CC_INFORMATIONAL_STEPS: {
    [PROVIDER_CHILD_CARE_ROUTES.STEPS]: 1,
    [PROVIDER_CHILD_CARE_ROUTES.JOBS]: 2,
  },

  PROVIDER_CC_ACCOUNT_CREATION: {
    [PROVIDER_CHILD_CARE_ROUTES.INDEX]: 1,
    [PROVIDER_CHILD_CARE_ROUTES.LOCATION]: 2,
    [PROVIDER_CHILD_CARE_ROUTES.ACCOUNT]: 3,
  },

  PROVIDER_CC_PROFILE_DETAILS: {
    [PROVIDER_CHILD_CARE_ROUTES.JOB_TYPES]: 1,
    [PROVIDER_CHILD_CARE_ROUTES.PREFERENCES]: 1,
    [PROVIDER_CHILD_CARE_ROUTES.AVAILABILITY]: 2,
    [PROVIDER_CHILD_CARE_ROUTES.PROFILE]: 3,
    [PROVIDER_CHILD_CARE_ROUTES.BIO]: 4,
    [PROVIDER_CHILD_CARE_ROUTES.PHOTO]: 5,
  },
  PROVIDER_MV_ACCOUNT_CREATION: {
    [PROVIDER_MULTI_VERTICAL_ROUTES.LOCATION]: 1,
    [PROVIDER_MULTI_VERTICAL_ROUTES.ACCOUNT]: 2,
    [PROVIDER_MULTI_VERTICAL_ROUTES.SERVICES]: 3,
  },
  PROVIDER_MV_DETAILS: {
    [PROVIDER_MULTI_VERTICAL_ROUTES.INDEX]: 0,
    [PROVIDER_MULTI_VERTICAL_ROUTES.PREFERENCES]: 1,
    [PROVIDER_MULTI_VERTICAL_ROUTES.PETCARE_PREFERENCES]: 1,
    [PROVIDER_MULTI_VERTICAL_ROUTES.HOURLY_RATE.INDEX]: 1,
    [PROVIDER_MULTI_VERTICAL_ROUTES.HOURLY_RATE.HOUSEKEEPING]: 1,
    [PROVIDER_MULTI_VERTICAL_ROUTES.HOURLY_RATE.SENIOR_CARE]: 1,
    [PROVIDER_MULTI_VERTICAL_ROUTES.HOURLY_RATE.TUTORING]: 1,
    [PROVIDER_MULTI_VERTICAL_ROUTES.APP_DOWNLOAD]: 3,
  },

  LTCG: {
    [LTCG_ROUTES.INSURANCE_CARRIER]: 1,
    [LTCG_ROUTES.NO_INSURANCE]: 1,
    [LTCG_ROUTES.ELIGIBLE_POLICY]: 2,
    [LTCG_ROUTES.POLICY_INELIGIBLE]: 2,
    [LTCG_ROUTES.WHERE]: 3,
    [LTCG_ROUTES.WHEN]: 4,
    [LTCG_ROUTES.LOCATION_INELIGIBLE]: 4,
    [LTCG_ROUTES.DETAILS_ABOUT_YOURSELF]: 5,
    [LTCG_ROUTES.CONTACT_INFO]: 6,
    [LTCG_ROUTES.SUCCESS]: 7,
  },

  SEEKER_INSTANT_BOOK_PET_CARE: {
    [SEEKER_INSTANT_BOOK_PET_CARE_ROUTES.INDEX]: 1,
    [SEEKER_INSTANT_BOOK_PET_CARE_ROUTES.CARE_NEEDS]: 1,
    [SEEKER_INSTANT_BOOK_PET_CARE_ROUTES.PET_DETAILS]: 2,
    [SEEKER_INSTANT_BOOK_PET_CARE_ROUTES.RECAP]: 2,
    [SEEKER_INSTANT_BOOK_PET_CARE_ROUTES.ACCOUNT_CREATION_EMAIL]: 3,
    [SEEKER_INSTANT_BOOK_PET_CARE_ROUTES.ACCOUNT_CREATION_NAME]: 4,
    [SEEKER_INSTANT_BOOK_PET_CARE_ROUTES.ACCOUNT_PASSWORD]: 5,
  },
};

export const PROVIDER_CC_FLOW_NAMES = [
  'PROVIDER_CC_INFORMATIONAL_STEPS',
  'PROVIDER_CC_ACCOUNT_CREATION',
  'PROVIDER_CC_PROFILE_DETAILS',
];
export const CZEN_BASE_PATH = '/';
export const CZEN_MHP = '/member/myAccount.do';
export const CZEN_MW_UPGRADE_PATH = '/mobile/seeker/upgradeMembership.do';
export const CZEN_MW_ENROLL_FLOW = 'enrollFlow=true';
export const CZEN_BACKGROUND_CHECK = '/rmember/enroll/resumeProviderEnrollment?serviceId=SENIRCARE';
export const CZEN_BACKGROUND_CHECK_CC =
  '/rmember/enroll/resumeProviderEnrollment?serviceId=CHILDCARE';
export const CZEN_DESKTOP_UPGRADE_PATH = '/dwb/upgrade/viewPage';
export const CZEN_DESKTOP_ENROLL_SEEKER_PATH = (subService: string, zip: string) =>
  `/dwb/visitor/enrollSeeker?memberType=seeker&serviceId=CHILDCARE&subService=${subService}&comeFrom=costOfChildcare&zip=${zip}&numOfInfants=0&numOfToddlers=0&numOfPreSchoolers=1&numOfPreKindergarteners=0`;
export const WELCOME_BACK_UPGRADE_MOBILE = '/mwb/sitter/upgrade/pricingPlans';
export const CZEN_MOBILE_NTH_DAY_RATE_CARD_PATH = '/mwb/seeker/upgrade/pricingPlans';
export const CZEN_DESKTOP_NTH_DAY_RATE_CARD_PATH =
  '/seeker/upgradeMembershipPlanActual.do?pt=stepId%3D0%26flowId%3DSEEKER_UPGRADE_UNLIM_PREF_PLUS_BGC_NEW_DESIGN%26&progressBarState=2.0';
export const CZEN_MW_SC_PROVIDER_SEARCH_PATH = (zip: string) =>
  `/mwb/member/sitterSearchTest?serviceId=SENIRCARE&zip=${zip}&overrideMfeRedirect=true`;
export const CZEN_MW_PC_PROVIDER_SEARCH_PATH = (zip: string) =>
  `/mwb/member/sitterSearchTest?serviceId=PETCAREXX&zip=${zip}&overrideMfeRedirect=true`;
export const CZEN_DESKTOP_PC_PROVIDER_SEARCH_PATH = (zip: string, searchRadius: number) =>
  `/visitor/captureSearchBar.do?sitterService=petCare&zipCode=${zip}&milesFromZipCode=${searchRadius}&searchPerformed=true&searchByZip=true&defaultZip=true&searchSource=MAG_GLASS&overrideMfeRedirect=true`;
export const CZEN_DESKTOP_SC_PROVIDER_SEARCH_PATH = (zip: string, searchRadius: number) =>
  `/visitor/captureSearchBar.do?sitterService=seniorCare&zipCode=${zip}&milesFromZipCode=${searchRadius}&searchPerformed=true&searchByZip=true&defaultZip=true&searchSource=MAG_GLASS&overrideMfeRedirect=true`;
export const CZEN_BLOCKLIST_PATH = '/visitor/bLMemberErrorPage.do';
export const CZEN_VISITOR_COOKIE_KEY = 'n_vis';
export const CZEN_SESSION_COOKIE_KEY = 'csc';
export const CZEN_JSESSIONID_COOKIE_KEY = 'JSESSIONID';
export const CZEN_SECURE_AUTH_COOKIE_KEY = 'acs';
export const CSC_SESSION_COOKIE_NAME = 'csc-session';
export const CARE_MID_COOKIE_NAME = 'care_mid';
export const CARE_DID_COOKIE_NAME = 'care_did';
export const CZEN_MEMBER_VERIFY_COOKIE_KEY = 'mc_verify';
export const CZEN_MW_RATE_CARD = '/mwb/test/seeker/pricingSchemeTest';
export const LEAD_AND_CONNECT_EXTERNAL_ENTRY =
  '/seeker/sc/lc/caregiver-profile/routing-in-progress';
export const CZEN_MW_SKIP_RATE_CARD_SC = '/mwb/member/sitterSearchTest?serviceId=SENIRCARE';
export const CZEN_DESKTOP_SKIP_RATE_CARD_SC =
  '/visitor/captureSearchBar.do?sitterService=seniorCare';
export const LOCAL_STORAGE_ERROR_TAG = 'LocalStorageError';
export const LOCAL_STORAGE_STATE_KEY = 'enrollment-mfe-state';
export const LOCAL_STORAGE_VERIFICATION_KEY = 'LocalStorageVerification';
export const LOCAL_STORAGE_VERIFICATION_VALUE = 'Verified';
export const LOCAL_STORAGE_GTM_QUEUE_KEY = 'gtm-push-queue';
export const CLIENT_SIDE_ERROR_TAG = 'ClientSideError';
export const CURRENT_STATE_MAJOR_VERSION = '2';
export const CURRENT_STATE_MINOR_VERSION = '0';
export const CURRENT_STATE_PATCH_VERSION = '0';
export const CURRENT_STATE_VERSION = `${CURRENT_STATE_MAJOR_VERSION}.${CURRENT_STATE_MINOR_VERSION}.${CURRENT_STATE_PATCH_VERSION}`;
// This constant considers paddings and margins as calc(100vh - (56px header + 24 + 24 paddings))
export const HEIGHT_MINUS_TOOLBAR = 'calc(100vh - 104px)';
export const ENROLLMENT_SESSION_ID_COOKIE_NAME = 'enrollment-session-id';
export const EMAIL_PASSWORD_NAME_JOINT_VALIDATION_ERROR =
  "Please don't use your name or email address in your password.";
export const UPGRADE_MEMBERSHIP_PLAN = (zipcode: string) =>
  `https://www.care.com/seeker/upgradeMembershipPlanActual.do?pt=stepId%3D0%26flowId%3DSEEKER_UPGRADE_UNLIM_PREF_PLUS_BGC_NEW_DESIGN%26&progressBarState=2.0&comeFrom=GLOBAL_HEADER&zip=${zipcode}`;
export const FEATURE_FLAG_OVERRIDE_COOKIE_NAME = 'ffov';
export const GET_TOP_CAREGIVERS_NO_RESULTS_MSG = 'GetTopCaregiversNoProfilesReturned';
export const NUMBER_OF_CAREGIVERS_TO_DISPLAY_CAREGIVERS_NEAR_YOU = 6;
export const NUMBER_OF_LEAD_CONNECT_RESULTS = (getFifteenCaregivers: boolean) =>
  getFifteenCaregivers ? 15 : 10;
export const LEAD_CONNECT_CZEN_REDIRECT_MSG = 'LeadAndConnectCzenRedirect';
export const CC_PRE_RATE_CARD_PATH = (czenGeneral: string) =>
  `${czenGeneral}/vis/auth/login?forwardUrl=${encodeURIComponent(
    `${czenGeneral}/app/ratecard/childcare/pre-rate-card?enrollFlow=true`
  )}`;
export const CC_RATE_CARD_PATH = '/app/ratecard/childcare/rate-card?enrollFlow=true';
export const PC_PRE_RATE_CARD_PATH = (czenGeneral: string) =>
  `${czenGeneral}/vis/auth/login?forwardUrl=${encodeURIComponent(
    `${czenGeneral}/app/ratecard/petcare/pre-rate-card?enrollFlow=true`
  )}`;
export const HK_PRE_RATE_CARD_PATH = (czenGeneral: string) =>
  `${czenGeneral}/vis/auth/login?forwardUrl=${encodeURIComponent(
    `${czenGeneral}/app/ratecard/housekeeping/pre-rate-card?enrollFlow=true`
  )}`;
export const TUTORING_PRE_RATE_CARD_PATH = (czenGeneral: string) =>
  `${czenGeneral}/vis/auth/login?forwardUrl=${encodeURIComponent(
    `${czenGeneral}/app/ratecard/tutoring/pre-rate-card?enrollFlow=true`
  )}`;
export const DC_PRE_RATE_CARD_PATH =
  '/app/ratecard/childcare/pre-rate-card?enrollFlow=true&subVertical=daycare';
export const DC_EPI_PRE_RATE_CARD_PATH =
  '/app/ratecard/childcare/pre-rate-card?enrollFlow=true&subVertical=daycare&isEarlyPremiumIntro=true';
export const HIGH_INTENT_PRE_RATE_CARD_PATH =
  '/app/ratecard/childcare/pre-rate-card?enrollFlow=true&comeFrom=enrollment';
export const MHP_FAVORITES_PATH = '/ppr.do#3';
export const LEAD_CONNECT_ROUTING_STEP = 'routing-in-progress';
export const SIX_MONTHS_IN_DAYS = 180;
export const CAREGIVERS_NEAR_YOU_REDIRECTION_TIMEOUT = 2300;

export enum OIDC_ERROR_TAGS {
  USER_FOUND = 'UserFound',
}

export type VerticalsAbbreviation = 'SC' | 'CC' | 'HK' | 'PC' | 'TU' | 'DC' | 'IB';

export enum CARE_DATES {
  RIGHT_NOW = 'RIGHT_NOW',
  WITHIN_A_WEEK = 'WITHIN_A_WEEK',
  IN_1_2_MONTHS = 'IN_1_2_MONTHS',
  JUST_BROWSING = 'JUST_BROWSING',
}

export enum CARE_DATE_LABELS {
  RIGHT_NOW = 'Right now',
  WITHIN_A_WEEK = 'Within a week',
  IN_1_2_MONTHS = 'In 1-2 months',
  JUST_BROWSING = 'Just browsing',
}

export enum DAY_CARE_DATE_LABELS {
  IMMEDIATELY = 'Immediately',
  WITHIN_A_WEEK = 'Within a week',
  IN_1_2_MONTHS = 'In 1-2 months',
  NO_RUSH = 'No rush',
}

export enum DAY_CARE_COST_IMPORTANCE {
  DOES_NOT_MATTER_MUCH = `Doesn't matter much`,
  BUDGET_FLEXIBLE = 'My Budget is flexible',
  DECIDING_FACTOR = 'Cost is a deciding factor',
}

export const DAY_CARE_COST_IMPORTANCE_PAGE = {
  TITLE: 'Finally, how important is cost to you when looking for the perfect daycare?',
  NEXT_BUTTON: 'Next',
  SCREEN_NAME: 'daycare-how-important-is-cost',
  MEMBER_ENROLLED: 'Member Enrolled',
  MEMBER_TYPE: 'Seeker',
};

export const PASSWORD_RULES = [
  'At least 6 characters',
  'Can’t contain your first, last name or email',
  'Can’t be a sequence of a single value (e.g “aaaaaa”)',
  'Can’t be a repeatable sequence (e.g “abcabcabc”)',
];

export const JOB_MFE_CC_PAJ = '/app/job/cc?flow=ENROLLMENT';
export const JOB_MFE_HK_PAJ = '/app/job/hk?flow=ENROLLMENT';
export const JOB_MFE_PC_PAJ = '/app/job/pc?flow=ENROLLMENT';
export const JOB_MFE_TU_PAJ = '/app/job/tu?flow=ENROLLMENT';
export const JOB_MFE_SC_PAJ = '/app/job/sc?flow=ENROLLMENT';
export const JOB_MFE_DC_PAJ_NTH_DAY = '/app/job/dc';
export const JOB_MFE_CC_PAJ_NTH_DAY = '/app/job/cc';

export const PAJ_NTH_DAY_PC = (zipcode: string) =>
  `/seeker/nthDayPAJPostJobV2.do?pt=stepId=0&serviceId=PETCAREXX&flowId=SEEKER_NTH_DAY_PAJ_API_TEST_FLOW&progressBarState=1.0&zip=${zipcode}&careGiverType=PCCGTYP001`;
export const PAJ_NTH_DAY_PC_MW = '/mwb/job/postController?serviceId=PETCAREXX';

export const PAJ_NTH_DAY_HK = (zipcode: string) =>
  `/seeker/nthDayPAJPostJobV2.do?pt=stepId=0&serviceId=HOUSEKEEP&flowId=SEEKER_NTH_DAY_PAJ_API_TEST_FLOW&progressBarState=1.0&zip=${zipcode}`;
export const PAJ_NTH_DAY_HK_MW = '/mwb/job/postController?serviceId=HOUSEKEEP';

export const PAJ_NTH_DAY_SC = (zipcode: string) =>
  `/seeker/nthDayPAJPostJobV2.do?pt=stepId=0&serviceId=SENIRCARE&flowId=SEEKER_NTH_DAY_PAJ_API_TEST_FLOW&progressBarState=1.0&zip=${zipcode}&careGiverType=SCCGTYP001`;
export const PAJ_NTH_DAY_SC_MW = '/mwb/job/postController?serviceId=SENIRCARE';

export const PAJ_NTH_DAY_TU = (zipcode: string) =>
  `/seeker/nthDayPAJPostJobV2.do?pt=stepId=0&serviceId=TUTORINGX&flowId=SEEKER_NTH_DAY_PAJ_API_TEST_FLOW&progressBarState=1.0&zip=${zipcode}`;
export const PAJ_NTH_DAY_TU_MW = '/mwb/job/postController?serviceId=TUTORINGX';

export const BOOKING_MFE_IB_ASSESSMENT = '/app/booking/otc/careNeeds';
export const BOOKING_MFE_IB_PET_CARE = '/app/booking/pc/ib/search?enrollFlow=true';
export const BOOKING_MFE_IB_PET_CARE_SELECT =
  '/app/booking/pc/ib/select?enrollFlow=true&isPullMatchForward=false';
export const BOOKING_MFE_IB_PET_CARE_MATCH =
  '/app/booking/pc/ib/match?enrollFlow=true&isPullMatchForward=true&pullMatchForwardVariationIndex=';

export const COVID_VACCINATION_OPTIONS = [
  {
    indicator: 'Yes',
    label: '',
    value: 'yes',
  },
  {
    indicator: 'No',
    label: '',
    value: 'no',
  },
];

export const COOKIE_FLOW_LOG_TAG = 'CookieFlow';
export const TERMS_OF_USE_URL = 'https://www.care.com/about/terms-of-use/';
export const PRIVACY_POLICY_URL = 'https://www.care.com/about/privacy-policy/';

export const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const ISO_FORMAT = 'YYYY-MM-DD';

export const comesFromVhp = 'vhp';
export const comesFromSeo = 'seo';
export type ComeFrom = typeof comesFromVhp | typeof comesFromSeo;

export const SERVICE_TYPE_BY_VERTICAL: { [key: string]: ServiceType } = {
  HK: ServiceType.HOUSEKEEPING,
  PC: ServiceType.PET_CARE,
  TU: ServiceType.TUTORING,
  CC: ServiceType.CHILD_CARE,
  DC: ServiceType.CHILD_CARE,
  IB: ServiceType.CHILD_CARE,
  SC: ServiceType.SENIOR_CARE,
};

export const ABBREVIATION_BY_SERVICE_TYPE: { [key: string]: VerticalsAbbreviation } = {
  [ServiceType.HOUSEKEEPING]: 'HK',
  [ServiceType.PET_CARE]: 'PC',
  [ServiceType.TUTORING]: 'TU',
  [ServiceType.CHILD_CARE]: 'CC',
  [ServiceType.SENIOR_CARE]: 'SC',
};

export const ERROR_CREATING_ACCOUNT = 'An error occurred creating your account, please try again.';
export const DAYCARE_ENROLLMENT_RECOMMENDATIONS_HEADER_TITLE =
  'Top results with availability in your area!';

export const HDYHAU_VERTICALS_ALLOWANCE: VerticalsAbbreviation[] = ['HK', 'TU', 'PC', 'DC'];

export const FLAGS_747 = Object.freeze({
  CC_ENROLLMENT_REMOVE_PHOTO_TEST_CELL:
    'cc-desktop-provider-enrollment-mfe-fg-proj-747-remove-photo',
  CC_ENROLLMENT_REMOVE_BIO_TEST_CELL:
    'cc-desktop-provider-enrollment-mfe-fg-proj-747-remove-bio-photo',
  CC_ENROLLMENT_REMOVE_ABOUTME_TEST_CELL:
    'cc-desktop-provider-enrollment-mfe-fg-proj-747-remove-aboutme-bio-photo',
  // mobile web test cells
  MOBILE_CC_ENROLLMENT_REMOVE_PHOTO_TEST_CELL:
    'mobile-provider-enrollment-cc-mfe-fg-proj-747-remove-photo',
  MOBILE_CC_ENROLLMENT_REMOVE_BIO_TEST_CELL:
    'mobile-provider-enrollment-cc-mfe-fg-proj-747-remove-bio-photo',
  MOBILE_CC_ENROLLMENT_REMOVE_ABOUTME_TEST_CELL:
    'mobile-provider-enrollment-cc-mfe-fg-proj-747-remove-aboutme-bio-photo',

  CC_DESKTOP_PROVIDER_ENROLLMENT_CC_MFE: 'cc-desktop-provider-enrollment-mfe',
  MOBILE_PROVIDER_ENROLLMENT_CC_MFE: 'mobile-provider-enrollment-cc-mfe',

  CC_DESKTOP_PROVIDER_ENROLLMENT_MFE_NON_FG: 'cc-desktop-provider-enrollment-mfe-non-fg',
  CC_DESKTOP_PROVIDER_ENROLLMENT_MFE_FG_WEB_PAYMENTS:
    'cc-desktop-provider-enrollment-mfe-fg-web-payments',
  MOBILE_PROVIDER_ENROLLMENT_CC_MFE_NON_FG: 'mobile-provider-enrollment-cc-mfe-non-fg',
  MOBILE_PROVIDER_ENROLLMENT_CC_MFE_FG_WEB_PAYMENTS:
    'mobile-provider-enrollment-cc-mfe-fg-web-payments',
  M4_747_DT: '747-M4-DT',
  M4_747_MW: '747-M4-MW',
});

export const MV_TEST_CELLS = Object.freeze({
  // petcare
  PC_DT_PROVIDER_ENROLLMENT_MV_PTA: 'pc-dt-provider-enrollment-mv-PTA',
  PC_MW_PROVIDER_ENROLLMENT_MV_PTA: 'pc-mw-provider-enrollment-mv-PTA',
  // housekeeping
  HK_DT_PROVIDER_ENROLLMENT_MV_PTA: 'hk-dt-provider-enrollment-mv-PTA',
  HK_MW_PROVIDER_ENROLLMENT_MV_PTA: 'hk-mw-provider-enrollment-mv-PTA',
  // tutoring
  TU_DT_PROVIDER_ENROLLMENT_MV_PTA: 'tu-dt-provider-enrollment-mv-PTA',
  TU_MW_PROVIDER_ENROLLMENT_MV_PTA: 'tu-mw-provider-enrollment-mv-PTA',
  // senior care
  SC_DT_PROVIDER_ENROLLMENT_MV_PTA: 'sc-dt-provider-enrollment-mv-PTA',
  SC_MW_PROVIDER_ENROLLMENT_MV_PTA: 'sc-mw-provider-enrollment-mv-PTA',
  // child care
  CC_DT_PROVIDER_ENROLLMENT_MV_PTA: 'cc-dt-provider-enrollment-mv-PTA',
  CC_MW_PROVIDER_ENROLLMENT_MV_PTA: 'cc-mw-provider-enrollment-mv-PTA',
});

export const PROVIDER_PETS = ['Dog', 'Cat'];

export enum PetCareServiceTypes {
  SITTING = 'SITTING',
  BOARDING = 'BOARDING',
  DAYCARE = 'DAYCARE',
  WALKING = 'WALKING',
}

export const PetcarePricingUnit = {
  OVER_NIGHT: 'per night',
  PER_DAY: 'per day',
  PER_30_MIN: 'per 30-minute walk',
  PER_HOUR: 'per 1-hour walk',
};

export const PetCareServiceTypesLabels: { [key in PetCareServiceTypes]: string } = {
  [PetCareServiceTypes.SITTING]: 'Sitting',
  [PetCareServiceTypes.BOARDING]: 'Boarding',
  [PetCareServiceTypes.DAYCARE]: 'Doggy daycare',
  [PetCareServiceTypes.WALKING]: 'Dog walking',
};

export const PETCARE_SERVICE_TYPES_OPTIONS = Object.freeze([
  {
    value: PetCareServiceTypes.SITTING,
    label: PetCareServiceTypesLabels[PetCareServiceTypes.SITTING],
    pricingText: [{ text: PetcarePricingUnit.OVER_NIGHT }],
  },
  {
    value: PetCareServiceTypes.BOARDING,
    label: PetCareServiceTypesLabels[PetCareServiceTypes.BOARDING],
    pricingText: [{ text: PetcarePricingUnit.OVER_NIGHT }],
  },
  {
    value: PetCareServiceTypes.DAYCARE,
    label: PetCareServiceTypesLabels[PetCareServiceTypes.DAYCARE],
    pricingText: [{ text: PetcarePricingUnit.PER_DAY }],
  },
  {
    value: PetCareServiceTypes.WALKING,
    label: PetCareServiceTypesLabels[PetCareServiceTypes.WALKING],
    pricingText: [{ text: PetcarePricingUnit.PER_30_MIN }, { text: PetcarePricingUnit.PER_HOUR }],
  },
]);
export const serviceTypeMapping = {
  CHILDCARE: ServiceType.CHILD_CARE,
  SENIRCARE: ServiceType.SENIOR_CARE,
  TUTORINGX: ServiceType.TUTORING,
  HOUSEKEEP: ServiceType.HOUSEKEEPING,
  PETCAREXX: ServiceType.PET_CARE,
};
export const CHILD_CARE_PROVIDER_EXPANDED_DEFAULT_PAGE_SIZE = 7;
export const CHILD_CARE_PROVIDER_EXPANDED_CURRENT_PAGE_SIZE = 5;

export const VALIDATION_MESSAGES = {
  FIRST_NAME_MIN: 'First name needs to have at least two letters.',
  FIRST_NAME_REQUIRED: 'First name is required',
  LAST_NAME_MIN: 'Last name needs to have at least two letters.',
  LAST_NAME_REQUIRED: 'Last name is required',
  PHONE_NUMBER_INVALID: 'Phone number is not valid',
  PHONE_NUMBER_REQUIRED: 'Phone number is required',
  EMAIL_REQUIRED: 'Email is required',
};

export const PHONE_NUMBER_PATTERN =
  /^(\+\d{1,2}\s?)?1?-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;

export const RECOMMENDATIONS_PAGE = {
  AMPLITUDE_EVENT: {
    CONTROL_GROUP: 0,
    EXPERIMENT_GROUP: 1,
    HOLD_OUT_GROUP: 2,
  },
};

export const LEADS_CONFIRMATION = {
  TITLE: 'Great job. Your daycare tour inquiries have been sent. Whats next?',
  DESCRIPTION: [
    `Daycares fill up fast. <span style="color:#172C42; font-weight: 800;">Give them a call</span> today to secure a spot.`,
    `Discover how <span style="color:#EF5844; font-weight: 800;">Premium</span> members save on daycare costs.`,
    `Explore other Care services like Babysitters, Nannies, and Tutoring.`,
  ],
  DISTANCE: {
    UNIT: 'MILES',
    SINGULAR: 'mile',
    PLURAL: 'miles',
  },
  CALL_BUTTON: {
    MW_LABEL: 'Call',
    DT_LABEL: 'View Phone Number',
  },
  BOOK_TOUR_BUTTON: {
    LABEL: 'Book a tour',
    BOOKED_LABEL: 'Booked tour',
    ERR_LABEL: 'Error booking',
  },
  NEXT_BUTTON: {
    LABEL: 'Next',
  },
  AMPLITUDE_EVENT: {
    PHONE_NUMBER_CLICKED: 'Phone Number Clicked',
    LEAD_CONTACT_CARD: 'daycare-leads-confirmation-lead-contact-details',
    MEMBER_TYPE: 'seeker',
    SCREEN_NAME: 'daycare-leads-confirmation',
    SCREEN_VIEWED: 'Screen Viewed',
    MEMBER_ENROLLED: 'Member Enrolled',
    CTA_NEXT: 'next',
    EXPERIMENT_GROUP: 0,
    CONTROL_GROUP: 1,
  },
  PHONE_NUMBER_PATTERN: /(\d{3})(\d{3})(\d{4})/,
};

export const PREMIUM_PROMO_BANNER_CONTENT = {
  header: 'Did you know?',
  subHeader: 'Premium members saved an average of $1,739* on daycare costs per child last year.',
};

export const PREMIUM_PROMO_MAX_COUNT = 4;
export const DAYCARE_SAVINGS_DISCLAIMER =
  '*Estimated savings off of 2021 national average daycare rate for one child';

export const AGE_GROUPS = [
  { label: 'Infant', age: '0-11 months', value: 'infant' },
  { label: 'Toddler', age: '1-3 years', value: 'toddler' },
  { label: 'Pre-school', age: '4-5 years', value: 'pre-school' },
  { label: 'School-aged', age: '6+ years', value: 'school-aged' },
];

export const SAFETY_CHECKS = [
  {
    label: 'CareCheck initial screening',
    value: 'initial-screening',
    icon: '/app/enrollment/icons/CareCheck.png',
  },
  {
    label: 'Criminal records search',
    value: 'c-records-search',
    icon: '/app/enrollment/icons/RecordsSearch.png',
  },
  {
    label: 'Motor vehicle records check',
    value: 'mv-records-check',
    icon: '/app/enrollment/icons/VehicleCheck.png',
  },
  {
    label: 'Investigative criminal plus check',
    value: 'investigative-check',
    icon: '/app/enrollment/icons/InvestigativeCheck.png',
  },
];

export const DAYCARE_WHO_NEEDS_CARE_V2 = {
  TITLE_ONE: `Let's find you a daycare.`,
  TITLE_TWO: `How old is your kiddo?`,
};

export const DDL_DEFAULT_DISTANCE = 10;
export const VIEW_MATCHES = 'View matches';

export const SEM_REMOVE_DAYCARE_OPTION_UTM_CODE = 'S_CC_Childcare_p_GGC00007';

export const SEO_PAGE_ID = 1001;
